<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-text-field
        v-model.trim="innerValue"
        :prepend-icon="prependIcon"
        :label="label"
        :type="type"
        :error-messages="errors"
        :readonly="readonly"
        :clearable="!readonly"
        :single-line="singleLine"
        :hide-details="hideDetails"
        :persistent-hint="persistentHint"
        :hint="hint"
        :dense="dense"
        :solo="solo"
        @click:clear="clear"
        @change="change"
        @keyup="keyup"
        @contextmenu.prevent>
      <template
          v-if="required"
          v-slot:prepend-inner>
        <v-icon
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      singleLine: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: [Boolean, String],
        default: false
      },
      persistentHint: {
        type: Boolean,
        default: false
      },
      solo: {
        type: Boolean,
        default: false
      },
      hint: {
        type: String,
        default: ''
      },
      dense: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      vid: {
        type: String,
        default: null
      },
      dataType: {
        type: String,
        default: 'text',
        validator: function (value) {
          // The value must match one of these strings
          return ['text', 'int', 'float'].indexOf(value) !== -1
        }
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', this.parseValue(val))
      // }
    },
    methods: {
      parseValue: function (value) {
        switch (this.dataType) {
        case 'int':
          if (!value && value !== '0' && value !== 0) {
            return null
          }
          return isNaN(value)
            ? value
            : Number.parseInt(value)
        case 'float':
          if (!value && value !== '0' && value !== 0) {
            return null
          }
          return isNaN(value)
            ? value
            : Number.parseFloat(value)

        default:
          return value
        }
      },
      clear: function () {
        this.$emit('input', null)
      },
      change: function (value) {
        this.$emit('input', this.parseValue(value))
        this.$emit('change', this.parseValue(value))
      },
      keyup: function () {
        this.$emit('input', this.parseValue(this.innerValue))
        this.$emit('keyup', this.parseValue(this.innerValue))
      }
    }
  }
</script>
